"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchedSteamQuery = exports.batchedCondenserQuery = exports.batchedDxQuery = exports.batchedFluidHeatingQuery = exports.batchedFluidCoolingQuery = exports.fluidCalculationInputsQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
// One generated row of the "Calculation inputs" sheet, in sheet column order. The four powers and
// two pressure drops come back as zero - those are what the supplier fills in - and the weights
// come back prefilled at 1.0.
const fluidCalculationInputRowFragment = (0, graphql_tag_1.default) `
  fragment ExpressFluidCalculationInputRow on FluidCalculationInputRowType {
    airFlow
    airInPressure
    dryAirInTemperature
    dryAirInHumidity
    dryFluidTemperatureIn
    dryFluidFlow
    dryWeightTotalPower
    dryTotalPower
    dryWeightPressureDrop
    dryPressureDrop
    wetAirInTemperature
    wetAirInHumidity
    wetFluidTemperatureIn
    wetFluidFlow
    wetWeightTotalPower
    wetTotalPower
    wetWeightSensiblePower
    wetSensiblePower
    wetWeightPressureDrop
    wetPressureDrop
    dryWarning
    wetWarning
  }
`;
// Geometry in, the operating points a supplier should be asked to run out - one result per coil,
// so a whole series can be prepared in one call. Unlike the coefficient fits this is synchronous
// and returns its data rather than emailing a workbook.
//
// Check warnings and lowLeveragePoints before posting a matrix: it can be generated for a coil
// that cannot actually be characterised well, and the diagnostics are how you tell.
exports.fluidCalculationInputsQuery = (0, graphql_tag_1.default) `
  query ExpressFluidCalculationInputs(
    $input: [FluidCalculationInputsRequestType!]!
  ) {
    user {
      coilProFluidCalculationInputs(input: $input) {
        coilId
        dryFluidFlow
        wetFluidFlow
        dryFluidVelocity
        wetFluidVelocity
        airFlowSpan
        airFlowCeilingSetBy
        minLeverage
        maxLeverage
        lowLeveragePoints
        warnings
        rows {
          ...ExpressFluidCalculationInputRow
        }
      }
    }
  }
  ${fluidCalculationInputRowFragment}
`;
exports.batchedFluidCoolingQuery = (0, graphql_tag_1.default) `
  query ExpressBatchedFluidCooling(
    $input: [FluidCoolingCoefficientsInputType!]!
  ) {
    user {
      batchedCoilProFluidCoolingCoefficients(input: $input)
    }
  }
`;
exports.batchedFluidHeatingQuery = (0, graphql_tag_1.default) `
  query ExpressBatchedFluidHeating(
    $input: [FluidHeatingCoefficientsInputType!]!
  ) {
    user {
      batchedCoilProFluidHeatingCoefficients(input: $input)
    }
  }
`;
exports.batchedDxQuery = (0, graphql_tag_1.default) `
  query ExpressBatchedDx($input: [DxCoefficientsInputType!]!) {
    user {
      batchedCoilProDxCoefficients(input: $input)
    }
  }
`;
exports.batchedCondenserQuery = (0, graphql_tag_1.default) `
  query ExpressBatchedCondenser($input: [CondensorCoefficientsInputType!]!) {
    user {
      batchedCoilProCondenserCoefficients(input: $input)
    }
  }
`;
exports.batchedSteamQuery = (0, graphql_tag_1.default) `
  query ExpressBatchedSteam($input: [SteamCoefficientsInputType!]!) {
    user {
      batchedCoilProSteamCoefficients(input: $input)
    }
  }
`;
//# sourceMappingURL=queries.js.map